<template>
    <div>
        <form-input
            v-model="item.title"
            label="Title"
            placeholder="Title"
            :error-message="getError('title')"
        />

        <form-input
            v-model="item.description"
            label="Description"
            placeholder="Description"
            component-type="textarea"
            :error-message="getError('description')"
        />

        <div class="form-group col-12">
            <label for="article">Article</label>
            <v-select
                v-model="item.article"
                label="name"
                :clearable="false"
                :options="articles"
                :class="{
                    'is-invalid': !!getError('articleId')
                }"
                @search="onArticleSearch"
                @input="onArticleChange"
            >
                <template #no-options="{ search }">
                    {{
                        search
                            ? 'Sorry, no matching options.'
                            : 'Type to search...'
                    }}
                </template>
            </v-select>
            <div class="invalid-feedback">
                {{ getError('articleId') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="date">Date</label>
            <input
                id="date"
                v-model="item.date"
                type="date"
                class="form-control"
                :class="{
                    'is-invalid': !!getError('date')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('date') }}
            </div>
        </div>

        <div class="row form-group col-12">
            <div class="col-5">
                <label for="startTime">Start Time</label>
                <input
                    id="startTime"
                    v-model="item.startTime"
                    type="datetime-local"
                    class="form-control"
                />
            </div>
            <div class="col-5">
                <label for="endTime">End Time</label>
                <input
                    id="endTime"
                    v-model="item.endTime"
                    type="datetime-local"
                    class="form-control"
                    :class="{
                        'is-invalid': !!getError('endTime')
                    }"
                />
                <div class="invalid-feedback">
                    {{ getError('endTime') }}
                </div>
            </div>
            <div class="col-2">
                <label for="name">Is hidden</label>
                <b-form-checkbox v-model="item.isHidden" switch />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import BaseForm from '@/components/elements/BaseForm';
import { ArticleStatus, ArticleType } from '@/enums/articles';

export default {
    name: 'AddEditForm',

    extends: BaseForm,

    data() {
        return {
            articles: []
        };
    },

    computed: {
        ...mapGetters({
            selectedLanguage: 'languages/selectedLanguage'
        }),

        popupArticleTypes() {
            return [
                ArticleType.EVENT,
                ArticleType.NEWSFLASH,
                ArticleType.SPEAKER_MESSAGE
            ];
        }
    },

    async created() {
        if (this.editMode) {
            const { startTime, endTime } = this.value;

            if (startTime) {
                this.value.startTime =
                    this.$dayjs(startTime).format('YYYY-MM-DDTHH:mm');
            }

            if (endTime) {
                this.value.endTime =
                    this.$dayjs(endTime).format('YYYY-MM-DDTHH:mm');
            }
        }
    },

    methods: {
        ...mapActions({
            fetchArticles: 'articles/index'
        }),

        async onArticleSearch(search, loading) {
            if (!search.length) {
                this.articles = [];

                return;
            }

            if (this.timer) {
                clearTimeout(this.timer);

                this.timer = null;
            }

            loading(true);

            this.timer = setTimeout(async () => {
                const filters = {
                    type: { value: this.popupArticleTypes, type: 'in' },
                    status: { value: [ArticleStatus.PUBLISHED], type: 'in' },
                    'language.code': {
                        value: [this.selectedLanguage.code],
                        type: 'eq'
                    }
                };

                try {
                    const { rows } = await this.fetchArticles({
                        search,
                        filters,
                        perPage: 50
                    });

                    this.articles = rows;
                } catch (err) {
                    console.error(err);
                } finally {
                    loading(false);
                }
            }, 500);
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.item,
                this.serverErrors,
                key
            );
        },

        onArticleChange(article) {
            this.item.articleId = article?.id || null;
        }
    }
};
</script>
